import U from '../js/utils';

export default async (status) => {
  const label = status != null && String(status).trim() !== '' ? String(status) : '—';
  const tagClassName = label.replace(/\s/g, '');
  const div = `
    <div class="statusTag inline-flex items-center pl-4 py-[6px] pr-6 ${tagClassName}">
      <span class="statusTag-dot h-3 w-3 bg-white rounded-full"></span>
      <span class="ml-2">${label}</span>
    </div>
  `;

  return U.createHTMLElementFromString(div);
};
